import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { buildLink, ContentRoute, RouteSlotInput } from '@caritas/ui';

import { useSiteSettings } from '../commons/site-settings';
import { MenuItem } from '../fragments/MenuItem.mappers';

const mapBreadcrumbObject = (menuItem: MenuItem) => ({
  title: menuItem.title,
  Link: menuItem.Link,
});

type Breadcrumbs = Exclude<
  RouteSlotInput<typeof ContentRoute, 'body', 'heroSection'>['input'],
  Function
>['breadcrumbItems'];

export const mapBreadcrumbItems = (
  path: string,
  menuItems?: Array<MenuItem>,
): Breadcrumbs => {
  if (!menuItems || !menuItems.length) return undefined;
  for (const menuItem of menuItems) {
    // We've reached the page we're after here
    if (menuItem.Link.href == path) return [mapBreadcrumbObject(menuItem)];
    // If we should keep looking
    if (menuItem.children) {
      const breadcrumbItems = mapBreadcrumbItems(path, menuItem.children);
      if (breadcrumbItems !== undefined) {
        breadcrumbItems.unshift(mapBreadcrumbObject(menuItem));
        return breadcrumbItems;
      }
    }
  }
};

export const mapLocationBreadcrumbItems = (
  pageContext: SilverbackPageContext,
  path: string,
  headline: string,
): Breadcrumbs => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { locationSearchPage } = useSiteSettings(pageContext);

  const breadcrumb = [];
  breadcrumb.push({
    title: locationSearchPage?.title || '',
    Link: buildLink({ href: locationSearchPage?.path || '' }),
  });

  breadcrumb.push({
    title: headline,
    Link: buildLink({ href: path }),
  });

  return breadcrumb;
};
